var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchLens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.3105 62.1989L65.5209 70.4091L70.8963 65.0335L62.6862 56.8232L57.3105 62.1989Z",
    fill: "#D0D5DD",
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8978 65.0333C71.611 64.3212 72.5778 63.9212 73.5857 63.9212C74.5935 63.9212 75.5602 64.3212 76.2734 65.0333L93.0317 81.7916C94.4573 83.2173 95.2583 85.151 95.2583 87.1671C95.2583 89.1834 94.4573 91.117 93.0317 92.5427C91.606 93.9683 89.6723 94.7693 87.6561 94.7693C85.6398 94.7693 83.7062 93.9683 82.2806 92.5427L65.5223 75.7845C64.8102 75.0712 64.4102 74.1046 64.4102 73.0967C64.4102 72.0888 64.8102 71.1222 65.5223 70.409L70.8978 65.0333Z",
    fill: "#E4E7EC",
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1457 11.2703C66.0908 17.2208 69.6362 25.1524 70.1049 33.5508C70.5735 41.9492 67.9328 50.226 62.6867 56.801C61.096 58.7833 59.2934 60.5858 57.3111 62.1765C52.1509 66.2987 45.908 68.8394 39.3358 69.4917C32.7635 70.144 26.1429 68.8802 20.2731 65.8528C14.4033 62.8254 9.53514 58.1638 6.25629 52.4306C2.97745 46.6975 1.42804 40.1378 1.79507 33.5435C2.16211 26.9492 4.42992 20.602 8.32475 15.2681C12.2196 9.93425 17.575 5.84168 23.7445 3.48435C29.914 1.12704 36.634 0.605746 43.0932 1.98342C49.5525 3.36109 55.475 6.57884 60.1457 11.2483V11.2703Z",
    fill: "#E4E7EC",
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8409 44.2657C11.1694 45.2365 11.5644 46.1837 12.0232 47.1003C19.8662 63.4032 41.7945 67.2587 54.7707 54.2824C58.6986 50.3453 61.2968 45.2784 62.2015 39.7911C63.1061 34.3037 62.272 28.671 59.8158 23.6813C58.5381 21.0836 56.841 18.7141 54.7928 16.6682C50.5304 12.4024 44.9456 9.71079 38.9534 9.0341C32.9611 8.35741 26.9168 9.73582 21.8105 12.9435C16.704 16.1512 12.8384 20.998 10.8469 26.69C8.85526 32.3819 8.85575 38.5814 10.8483 44.273L10.8409 44.2657Z",
    fill: "#F2F4F7",
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLens);
export default __webpack_public_path__ + "0c31f7d015e1168aa203f3a8033bc236.svg";
export { ForwardRef as ReactComponent };